export function transformFromBackendReport(backendType: any) { // eslint-disable-line
  return {
    ...backendType,
    selected_template_layout: JSON.parse(backendType.selected_template_layout)
  };
}
